// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    AllocatedPhoneAPIModel,
    AllocatedPhoneAPIModelFromJSON,
    AllocatedPhoneAPIModelFromJSONTyped,
    AllocatedPhoneAPIModelToJSON,
    SbpInvoiceCidAPIModel,
    SbpInvoiceCidAPIModelFromJSON,
    SbpInvoiceCidAPIModelFromJSONTyped,
    SbpInvoiceCidAPIModelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SbpInvoiceAPIModel
 */
export interface SbpInvoiceAPIModel {
    /**
     * 
     * @type {number}
     * @memberof SbpInvoiceAPIModel
     */
    id: number;
    /**
     * 
     * @type {SbpInvoiceCidAPIModel}
     * @memberof SbpInvoiceAPIModel
     */
    cid: SbpInvoiceCidAPIModel;
    /**
     * 
     * @type {number}
     * @memberof SbpInvoiceAPIModel
     */
    accountId: number;
    /**
     * 
     * @type {Date}
     * @memberof SbpInvoiceAPIModel
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof SbpInvoiceAPIModel
     */
    expiresAt: Date;
    /**
     * 
     * @type {AllocatedPhoneAPIModel}
     * @memberof SbpInvoiceAPIModel
     */
    allocatedPhone: AllocatedPhoneAPIModel;
    /**
     * 
     * @type {string}
     * @memberof SbpInvoiceAPIModel
     */
    status: SbpInvoiceAPIModelStatusEnum;
}

/**
* @export
* @enum {string}
*/
export enum SbpInvoiceAPIModelStatusEnum {
    Created = 'Created',
    InProgress = 'InProgress',
    Succeeded = 'Succeeded',
    Cancelled = 'Cancelled',
    Unknown = 'Unknown'
}

export function SbpInvoiceAPIModelFromJSON(json: any): SbpInvoiceAPIModel {
    return SbpInvoiceAPIModelFromJSONTyped(json, false);
}

export function SbpInvoiceAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SbpInvoiceAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'cid': SbpInvoiceCidAPIModelFromJSON(json['cid']),
        'accountId': json['accountId'],
        'createdAt': (new Date(json['createdAt'])),
        'expiresAt': (new Date(json['expiresAt'])),
        'allocatedPhone': AllocatedPhoneAPIModelFromJSON(json['allocatedPhone']),
        'status': json['status'],
    };
}

export function SbpInvoiceAPIModelToJSON(value?: SbpInvoiceAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'cid': SbpInvoiceCidAPIModelToJSON(value.cid),
        'accountId': value.accountId,
        'createdAt': (value.createdAt.toISOString()),
        'expiresAt': (value.expiresAt.toISOString()),
        'allocatedPhone': AllocatedPhoneAPIModelToJSON(value.allocatedPhone),
        'status': value.status,
    };
}


